import * as reduxAction from 'redux-actions';

export const SET_IS_LOADING = "SET_IS_LOADING"

export const USER_LOADING = "USER"
export const ACTIVITY_LOADING = "ACTIVITY"
export const ACTIVITY_CATEGORY_LOADING = "ACTIVITYCATEGORY"
export const ACTIVITY_THEME_LOADING = "ACTIVITYTHEME"
export const PORTAL_SEARCH_LOADING = "PORTALSEARCH"


export function setIsLoading(stateKey:string, isLoading: boolean ){
    return reduxAction.createAction(SET_IS_LOADING)({stateKey, isLoading})
}





// WEBPACK FOOTER //
// ./src/Entities/PortalLoadingState/PortalLoadinState.Actions.ts